module.exports = require("@ecom-alliance/components");